export const ADMIN = "Admin";
export const SAINSBURYS = "Sainsburys";
export const LIGHTING_SETUP = "Lighting.Setup";
export const LIGHTING_OVERRIDES_READ = "Lighting.Overrides.Read";
export const LIGHTING_OVERRIDES_WRITE = "Lighting.Overrides.Write";
